import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    fields: 'mt-8 flex flex-col gap-3 sm:mt-10',
    subscribe: 'my-8',
    agreement: 'mb-6',
    button: 'w-full',
    close: 'heading-m-regular text-accent mt-10 cursor-pointer'
  }
});
